<template>
<div>
    <template v-if="action=='view'">
        <div class="table-settings mb-4 " v-if="allData.length>0 || q!=''">
            <div class="row align-items-center justify-content-between">
                <div class="col col-md-6 col-lg-3 col-xl-4">
                    <!-- <form action="https://5ineprojects.com/BNectar/backend/api/import.php" method="post" enctype="multipart/form-data"> -->
                    <!-- <h3 class="">Import</h3>
                    <br />
                    <input type="file" id="importcsv" ref="importfile" name="importfile" class="from-control">
                    <input type="button" @click="importExcel" class=" btn btn-primary" value="Submit"> -->
                </div>
                <div class="col-4 col-md-2  pl-md-0 ">
                    <router-link class="btn btn-success" :to="{name : 'index', params: { page: 'varient', action: 'add', id: id,  code: code }}"><span class="fas fa-edit mr-2"></span>Add Varient</router-link>
                </div>
            </div>
        </div>
        <div class="card border-light shadow-sm mb-4">
            <div class="card-body" v-if="(allData.length>0)">
                <table class="table table-hover">
                    <thead class="thead-light">
                        <tr>
                            <th>#</th>
                            <th>Name</th>
                            <th>Image</th>
                            <th>Inventory</th>
                            <th>Status</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody v-if="allData.length>0">
                        <tr v-for="data in allData" :key="data.id">
                            <td>
                                <a href="#" class="font-weight-bold">
                                    {{data.id}}
                                </a>
                            </td>
                            <td><span class="font-weight-normal">{{data.name}}</span></td>
                            <td><span class="font-weight-normal">
                                    <img v-if="data.front_image!=''" :src="$root.URL_ROOT+'uploads/Product/'+data.front_image" width="50">
                                </span></td>
                            <td><span class="font-weight-normal">{{data.stock}}</span></td>
                            <!-- <td><span class="font-weight-normal">{{data.added_by}}</span></td> -->
                            <td><span class="font-weight-bold">
                                    <a class="btn btn-danger btn-xs" href="#" @click="update('mss_product',1,data.id);data.status=1" v-if="data.status==0">Inactive</a>
                                    <a class="btn btn-success btn-xs" href="#" @click="update('mss_product',0,data.id);data.status=0" v-if="data.status==1">Active</a>
                                </span></td>
                            <td>
                                <div class="btn-group">
                                    <router-link class="btn btn-primary btn-xs" :to="{name : 'index', params: { page: page, action: 'edit', id: data.id , code: code  }}"><span class="fas fa-edit mr-2"></span>Edit</router-link>
                                    <a @click="remove(data.id)" class="btn btn-danger btn-xs" href="#"><span class="fas fa-trash-alt mr-2"></span>Remove</a>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                    <tbody v-else>
                        <tr>
                            <td class="text-center" colspan="5">No record found</td>
                        </tr>
                    </tbody>
                </table>
                <pagination v-model="page2" :records="totalCount" :per-page="perPage" />
            </div>
            <div class="card-body text-center" v-else>
                <div v-if="loading">
                    loading...
                </div>
                <div v-else>
                    <!-- <InlineSvg name="noproduct"></InlineSvg> -->
                    <div>
                        <h3>Add and manage your {{page}}</h3>
                        <p>This is where you’ll add {{page}} and manage your {{page}}. You can also improve your seo for {{page}} by adding.</p>
                        <router-link :to="{name : 'index', params: { page: page, action: 'add', id:0, code: code }}" class="btn btn-primary" type="button">Add {{page}}</router-link>
                        <br><br><br>
                    </div>
                </div>
            </div>
        </div>
    </template>
    <template v-else-if="action=='add' || action=='edit'">
        <div class="row">
            <div class="col-12 col-xl-8">
                <div class="card card-body bg-white border-light shadow-sm mb-4">
                    <h2 class="h5 mb-4">General information</h2>
                    <div class="row">
                        <!-- <div class="col-md-6 mb-3">
                            <MssInput v-model="form.linkname" placeholder="Enter Product Link" required="required"></MssInput>
                        </div> -->
                        <div class="col-md-12 mb-3">
                            <MssInput v-model="form.name" placeholder="Enter Product Heading" required="required"></MssInput>
                        </div>
                    </div>
                    <div class="row align-items-center">
                        <div class="col-md-12 mb-3">
                            <!-- <div class="pull-right">
                                <MssInput type="switch" v-model="isEditor" :placeholder="isEditor ? 'Source Code' : 'View Editor'"></MssInput>
                            </div>
                            <label for="birthday">Page Body <span class="red-color">*</span></label>
                            <vue-editor v-if="isEditor" v-model="form.description" :editorToolbar="fullToolbar"></vue-editor>
                            <MssInput v-else type="textarea" v-model="form.description"></MssInput> -->

                             <MssInput type="textarea" v-model="form.description" placeholder="Enter Product Description"></MssInput>
                             
                        </div>
                    </div>
                </div>

                 <h2 class="h5 mb-4">Specifications</h2>
               
                <div class="form-group row" v-for="(input,k) in inputs" :key="k">
                    <div class="col-md-6">
                        <input type="text" class="form-control" placeholder="Name" v-model="input.name" />
                    </div>
                    <div class="col-md-6">
                        <input type="text" class="form-control" placeholder="Value" v-model="input.value" />
                    </div>
                  
                   
                    <span>
                        <i
                        class="fa fa-minus-circle"
                        style="margin:10px 30px;font-size:22px"
                        @click="removeF(k)"
                                v-show="k || ( !k && inputs.length > 1)"
                        
                        ></i>
                    
                        <i
                        class="fa fa-plus-circle"
                         style="margin:10px 30px;font-size:22px"
                        @click="add(k)"
                        v-show="k == inputs.length-1"
                        ></i>
                    </span>
                </div>

                 <h2 class="h5 mb-4">Feature</h2>

                <multiselect style="margin-bottom: 30px;" v-model="value" :options="options" :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true" placeholder="Pick some" label="name" track-by="name" :preselect-first="true">
                    <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} options selected</span></template>
                </multiselect>


                <div class="card card-body bg-white border-light shadow-sm mb-4 row">
                    <div class="col-md-6 mb-3">
                        <label>Product Image</label>
                        <input class="form-control" type="file" id="file" ref="front_image" accept="image/*" />

                    </div>
                    <div class="col-md-6 mb-3">
                        <img v-if="form.front_image!=''" :src="$root.URL_ROOT+'uploads/Product/'+form.front_image" width="50">
                    </div>
                </div>
                <div class="card card-body bg-white border-light shadow-sm mb-4">
                    <h2 class="h5 mb-4">Media <span>( Select multiple images )</span> </h2>
                    <!-- <MssImage folder="product" v-model="form.image_collection" :selected="form.image_collection"></MssImage> -->
                    <input class="form-control" type="file" id="file" ref="image_collection" multiple accept="image/*" />
                    <div class="py-3 ">
                        <img v-for="(images,key) in allimages" :key="key" :src="$root.URL_ROOT+'uploads/Product/'+images" class="mx-3" width="50">
                    </div>
                </div>

            </div>
            <div class="col-12 col-xl-4 sidebar-stricky">
                <div class="card card-body bg-white border-light shadow-sm mb-4">
                    <h2 class="h5 mb-4">Visibility</h2>
                    <div class="row">
                        <div class="col-md-12 mb-3">
                            <MssInput type="switch" v-model="form.status" placeholder="Visible this page to all"></MssInput>
                        </div>
                        <div class="col-md-12 mb-3">
                            <MssInput type="switch" v-model="form.is_featured" placeholder="This Product is featured"></MssInput>
                        </div>
                        <!--
                        <div class="col-md-12 mb-3">
                            <MssInput type="switch" v-model="form.is_offer" placeholder="Comes in offer"></MssInput>
                        </div>
                       
                         <div class="col-md-12 mb-3">
                            <MssInput type="switch" v-model="form.is_seller" placeholder="This Product is Best Seller"></MssInput>
                        </div>
                        -->

                        <div class="col-md-12 mb-3">
                            <div>
                                <button @click="submit" class="btn btn-info btn-block" v-if="action=='add'">Publish</button>
                                <button @click="submit" class="btn btn-success btn-block" v-else>Update</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card card-body bg-white border-light shadow-sm mb-4">
                    <h2 class="h5 mb-4">Product Manage</h2>
                    <div class="row">
                        <!-- <div class="col-md-6 mb-3">
                            <MssInput v-model="form.shipping" placeholder="Shipping Amount"></MssInput>
                        </div> -->
                        <div class="col-md-12 mb-3">
                            <MssInput v-model="form.stock" placeholder="Available Stock"></MssInput>
                        </div>
                        <div class="col-md-12 mb-3">
                            <div>
                                <label for="lorder">Category</label>

                                <MssSelect v-model="form.category" placeholder="Select" :reduce="categoryList => categoryList.code" :options="categoryList"></MssSelect>

                            </div>
                        </div>
                        <div class="col-md-12 mb-3 " v-if="showSubCategory">
                            <div>
                                <label for="lorder">Sub Category</label>
                                <MssSelect v-model="form.subcategory" placeholder="Select" :reduce="subcategoryList => subcategoryList.code" :options="subcategoryList"></MssSelect>
                            </div>
                        </div>
                        <div class="col-md-12 mb-3 " v-if="showSuperSubCategory">
                            <div>
                                <label for="lorder">Super Sub Category</label>
                                <MssSelect v-model="form.supSubcateory" placeholder="Select" :reduce="supersubcategoryList => subcategoryList.code" :options="supersubcategoryList"></MssSelect>
                            </div>
                        </div>
                        <div class="col-md-12 mb-3 ">
                            <div>
                               
                                <!--<MssSelect v-model="form.size" taggable multiple push-tags></MssSelect>-->
                                 <MssInput v-model="form.size"  placeholder="Product Size" ></MssInput>
                            </div>
                        </div>

                        <div class="col-md-12 mb-3 ">
                            <div>
                                <!-- <label for="lorder">Product Size <i> (Add size press enter to add new size ) </i> </label> -->
                                <MssInput v-model="form.thickness"  placeholder="Product Thickness" ></MssInput>
                            </div>
                        </div>

                        <!--<div class="col-md-12 mb-3 ">
                            <div>
                                <label for="lorder"> </label>
                                <MssInput v-model="form.color" placeholder="Product Color Code (Color code add with '#' tag like '#000')" required="required"></MssInput>
                            </div>
                        </div>-->
                    </div>
                </div>
                <div class="card card-body bg-white border-light shadow-sm mb-4">
                    <h2 class="h5 mb-4">Price</h2>
                    <div class="row">
                        <div class="col-md-12 mb-3">
                            <MssInput type="number" v-model="form.selling_cost" placeholder="Price" required></MssInput>
                        </div>
                        <div class="col-md-12 mb-3">
                            <MssInput type="number" v-model="form.purchese_cost" placeholder="Compare at price"></MssInput>
                        </div>

                         <div class="col-md-12 mb-3">
                            <MssInput type="number" v-model="form.per_sq_ft" placeholder="per sq ft price"></MssInput>
                        </div>
                    
                    </div>
                    <!--<div class="row ">
                        <div class="col-md-6 mb-3">
                            <MssInput type="number" v-model="form.market_price" placeholder="Cost per item"></MssInput>
                        </div>
                        <div class="col-md-6 mb-3">
                            <div class="row">
                                <div class="col-md-6">
                                    <label for="Margin_mpul4y1bk">Margin: </label><br>
                                    <span v-if="form.selling_cost && form.market_price">{{parseFloat(100-(form.market_price*100)/form.selling_cost)}}%</span>
                                    <span v-else>-</span>
                                </div>
                                <div class="col-md-6">
                                    <label for="Profit_mpul4y1bk">Profit: </label><br>
                                    <span v-if="form.selling_cost && form.market_price">{{parseFloat(form.selling_cost-form.market_price)}}</span>
                                    <span v-else>0</span>
                                </div>
                            </div>
                        </div>
                    </div>-->
                </div>
            </div>
        </div>
    </template>
</div>
</template>

<script>
import $ from 'jquery'
import axios from 'axios'
import Pagination from 'vue-pagination-2';
import Multiselect from 'vue-multiselect'
import {
    VueEditor
} from "vue2-editor";
export default {
    components: {
        VueEditor,
        Pagination,
        Multiselect
    },
    props: [
        "page", "action", "id", "code"
    ],
    data() {
        return {
            inputs: [
                {
                    name: "",
                    value: ""
                }
            ],
            value: [],
            options: [
                { name: 'Borer & Fungus Proof,Anti-Termite Guarantee', image: '1.381472c7.jpg' },
                { name: 'High Resistance to All Climatic Conditions', image: '2.c4f100b8.jpg' },
                { name: 'Bonded with Melamine FortifiedUrea Formaldehyde Synthetic Adhesive', image: '3.79c0628c.jpg' },
                { name: 'Lifetime Warranty On Premium Offerings', image: '4.671b177d.jpg' },
                { name: 'Lifetime Warranty On Premium Offerings', image: '5.61714a44.jpg' },
                
            ],
            page2: 1,
            totalCount: 0,
            newAry: [],
            perPage: 5,
            allimages: null,
            isEditor: true,
            showSubCategory: false,
            showSuperSubCategory: false,
            q: '',
            varient: false,
            loading: false,
            allData: [],
            varient_name: '',
            varient_type: [],
            form: {
                id: null,
                language: 'en',
                name: '',
                status: true,
                detail: '',
                meta_title: '',
                meta_description: '',
                meta_keywords: '',
                image_collection: '',
                added_by: 0,
                linkname: '',
                shipping: 0,
                selling_cost: 0,
                purchese_cost: 0,
                per_sq_ft:0,
                is_featured: 0,
                is_offer: 0,
                under_of: 0,
                stock: 0,
                varient: [],
                tag: [],
                category: 0,
                subcategory: 0,
                supSubcateory: 0,
                brand_id: 0,
                front_image: '',
                thickness: '',
                size: '',
                type: 'addVariant'
            },
            editSEO: false,
            defaultSEO: true,
            userList: [],
            supersubcategoryList: [],
            subcategoryList: [],
            categoryList: [],
            brandList: [],
            fullToolbar: [
                [{
                    'font': []
                }],
                [{
                    'header': [false, 1, 2, 3, 4, 5, 6, ]
                }],
                [{
                    'size': ['small', false, 'large', 'huge']
                }],
                ['bold', 'italic', 'underline', 'strike'],
                [{
                    'align': [false, 'justify', 'center', 'right']
                }],
                //[{ 'header': 1 }, { 'header': 2 }],
                //['blockquote', 'code-block'],
                [{
                    'list': 'ordered'
                }, {
                    'list': 'bullet'
                }, {
                    'list': 'check'
                }],
                //[{ 'script': 'sub'}, { 'script': 'super' }],
                [{
                    'indent': '-1'
                }, {
                    'indent': '+1'
                }],
                [{
                    'color': []
                }, {
                    'background': []
                }],
                ['link', 'image', 'video', 'formula'],
                //[{ 'direction': 'rtl' }],
                ['clean'],
            ],
            viewAllUrl: '',
            // URL_ROOT:'https://5ineprojects.com/Rapidea/backend/api/'
        }
    },
    methods: {
        add(index) {
            this.inputs.push({ name: "", value: "" });
        },
        removeF(index) {
            this.inputs.splice(index, 1);
        },
        importExcel() {
            if (this.form.name === '') {
                this.$toasted.global.error({
                    message: 'Please enter Product Name'
                })
            } else {
                var ev = this
                this.file = this.$refs.importfile.files[0];
                let formData = new FormData();

                formData.append('importfile', this.file);
                axios({
                    method: 'POST',
                    url: this.$root.URL_ROOT + 'import.php',
                    data: formData
                }).then(function (response) {
                    //console.log(response)
                    // var data = response.data
                    // if (data.status == "success") {
                    setTimeout(() =>
                        ev.$swal({
                            toast: true,
                            position: 'top-end',
                            timer: 5000,
                            icon: 'success',
                            timerProgressBar: true,
                            title: 'Action perform successfully'
                        }), 5000);
                    ev.allDatas()
                    // } else {
                    //     var message = ""
                    //     setTimeout(() => ev.$swal('Error Please check', message, "error"), 1000);

                    // }

                })
            }
        },
        changePage() {
            this.allData = [];
            var preCount = (this.perPage * this.page2);
            var temp = this.perPage;
            var newPP = (preCount) - temp;
            // //console.log(this.newAry);
            for (var i = 0; i < temp; i++) {
                if (this.newAry[newPP]) {
                    this.allData[i] = this.newAry[newPP];
                    newPP++;
                }
            }
           //console.log(this.allData);
        },
        update(table, status, id) {
            var param = {
                id: id,
                status: status,
                table: table,
                type: 'commonStatus'
            }
            axios({
                method: 'POST',
                url: this.$root.URL_ROOT + 'api.php',
                data: param
            }).then(function (response) {
                var data = response.data;
               //console.log('status', data)
            })
        },
        addInit() {
            //this.getUsers();
            this.getCategory();
            this.reset()
            //this.getBrand();
        },
        editInit() {
            this.getDetail();
            // this.getUsers();
            this.getCategory();
            // this.getBrand();

        },
        viewInit() {
            this.viewAllUrl = this.URL_ROOT + 'admin/' + this.page + '/all'
            this.allDatas(true)
        },
        reset() {
            this.form = {
                id: null,
                language: 'en',
                name: '',
                status: true,
                detail: '',
                meta_title: '',
                meta_description: '',
                meta_keywords: '',
                image_collection: '',
                added_by: 0,
                linkname: '',
                shipping: 0,
                selling_cost: 0,
                purchese_cost: 0,
                per_sq_ft:0,
                is_featured: 0,
                is_offer: 0,
                stock: 0,
                varient: [],
                tag: [],
                category: 0,
                subcategory: 0,
                supSubcateory: 0,
                brand_id: 0,
                front_image: '',
                type: 'addVariant',
                thickness:'',
            };
        },
        getUsers() {
            var pList = [];
            $.ajax({
                "method": 'GET',
                "url": this.URL_ROOT + 'admin/user/alluser/?field=name,id,avatar',
                "success": (response) => {
                    if (response.status == "success") {
                        $.each(response.data, function (key, param) {
                            //console.log(param,key);
                            pList.push({
                                label: param.name,
                                code: param.id
                            })
                        })
                    }
                    this.userList = pList;
                }
            })
        },
        getCategory() {
            //var pList = [];
            var ev = this;
           //console.log("dasdasdad");
            axios({
                method: 'POST',
                url: ev.$root.URL_ROOT + 'api.php',
                data: {
                    type: 'getCategorySelect',
                }
            }).then(function (response) {
                var data = response.data;
               //console.log(data);
                ev.categoryList = data.category;
               //console.log(ev.categoryList);
            })

            /*
            $.ajax({
                "method": 'GET',
                "url": this.URL_ROOT + 'admin/category/allcategory/?field=id,heading,is_parent',
                "success": (response) => {
                    if (response.status == "success") {
                        $.each(response.data, function (key, param) {
                            pList.push({
                                label: param.heading,
                                code: param.id
                            })
                        })
                    }
                   //console.log(response)
                    this.categoryList = pList;
                }
            })
            */
        },
        getSubCategory(id) {
            //var pList = [];
            var ev = this;
           //console.log(id);
            axios({
                method: 'POST',
                url: ev.$root.URL_ROOT + 'api.php',
                data: {
                    type: 'getSubCategorySelect',
                    category_id: id
                }
            }).then(function (response) {
                var data = response.data;
               //console.log(response);
                if (data.status == 'success') {
                    ev.subcategoryList = data.subcategory;
                    ev.showSubCategory = true;
                   //console.log(ev.subcategoryList);
                }

            })

            /*
            $.ajax({
                "method": 'GET',
                "url": this.URL_ROOT + 'admin/category/allcategory/?field=id,heading,is_parent',
                "success": (response) => {
                    if (response.status == "success") {
                        $.each(response.data, function (key, param) {
                            pList.push({
                                label: param.heading,
                                code: param.id
                            })
                        })
                    }
                   //console.log(response)
                    this.categoryList = pList;
                }
            })
            */
        },
        getSuperSubCategory(id) {
            //var pList = [];
            var ev = this;
           //console.log(id);
            axios({
                method: 'POST',
                url: ev.$root.URL_ROOT + 'api.php',
                data: {
                    type: 'getSuperSubCategorySelect',
                    category_id: id
                }
            }).then(function (response) {
                var data = response.data;
               //console.log(response);
                if (data.status == 'success') {
                    ev.supersubcategoryList = data.subcategory;
                    ev.showSuperSubCategory = true;
                   //console.log(ev.supersubcategoryList);
                }

            })

            /*
            $.ajax({
                "method": 'GET',
                "url": this.URL_ROOT + 'admin/category/allcategory/?field=id,heading,is_parent',
                "success": (response) => {
                    if (response.status == "success") {
                        $.each(response.data, function (key, param) {
                            pList.push({
                                label: param.heading,
                                code: param.id
                            })
                        })
                    }
                   //console.log(response)
                    this.categoryList = pList;
                }
            })
            */

        },
        getBrand() {
            var pList = [];
            $.ajax({
                "method": 'GET',
                "url": this.URL_ROOT + 'admin/brand/allbrand/?field=id,heading,is_parent',
                "success": (response) => {
                    if (response.status == "success") {
                        $.each(response.data, function (key, param) {
                            pList.push({
                                label: param.heading,
                                code: param.id
                            })
                        })
                    }
                   //console.log(response)
                    this.brandList = pList;
                }
            })
        },
        getDetail() {
            var ev = this
            var param = {
                id: this.id,
                type: 'getSingleProduct'
            }
            axios({
                method: 'POST',
                url: this.$root.URL_ROOT + 'api.php',
                data: param
            }).then(function (response) {
               //console.log(response)
                var data = response.data;
                ev.form = data.product
                ev.inputs=JSON.parse(data.product.items);
                ev.value=JSON.parse(data.product.feature);
                // var t=JSON.parse(data.product.items)
                // console.log(t)
                ev.allimages = JSON.parse(ev.form.image_collection)
            })
            // this.loading = true
            // $.ajax({
            //     "method": 'GET',
            //     "url": this.URL_ROOT + 'admin/' + this.page + '/detail/' + this.id,
            //     "success": (response) => {
            //        //console.log(response)
            //         this.form = response;
            //         this.allimages = JSON.parse(this.form.image_collection)
            //         this.loading = false
            //     }
            // })
        },
        allDatas() {
            var ev = this
            var product_code = 0
            if (ev.code > 0) {
                product_code = parseFloat(ev.code)
            }

            axios({
                method: 'POST',
                url: this.$root.URL_ROOT + 'api.php',
                data: {
                    type: 'getVariant',
                    product_code: product_code
                }
            }).then(function (response) {
                var data = response.data;
                ev.allData = data.product;
                ev.newAry = data.product;
                ev.totalCount = data.count;
                ev.changePage();

            })
        },
        submit() {
            if (this.form.name === '') {
                this.$toasted.global.error({
                    message: 'Please enter Product Name'
                })
            } else if (this.form.purchese_cost === '') {
                this.$toasted.global.error({
                    message: 'Please enter Compare price'
                })
            } else if (this.form.selling_cost === '') {
                this.$toasted.global.error({
                    message: 'Please enter Price'
                })
            } else if (this.form.per_sq_ft === '') {
                this.$toasted.global.error({
                    message: 'Please enter per sq ft price'
                })
            } else if (this.form.category === '') {
                this.$toasted.global.error({
                    message: 'Please select category'
                })
            } else if (this.form.stock === '') {
                this.$toasted.global.error({
                    message: 'Please enter stock'
                })
            } else if (this.form.description === '') {
                this.$toasted.global.error({
                    message: 'Please enter product description'
                })
            } else {
                var ev = this
                this.file = this.$refs.front_image.files[0];
                let formData = new FormData();
                if (this.action == 'edit') {
                    this.form.id = this.id;
                    this.form.type = 'editVariant';
                    formData.append('id', this.id);
                }
                formData.append('name', this.form.name);
                // formData.append('image_collection', this.$refs.image_collection.files);
                for (var i = 0; i < this.$refs.image_collection.files.length; i++) {
                    let file = this.$refs.image_collection.files[i];
                    formData.append('image_collection[' + i + ']', file);
                }
                formData.append('front_image', this.file);
                formData.append('purchese_cost', this.form.purchese_cost);
                formData.append('selling_cost', this.form.selling_cost);
                formData.append('per_sq_ft', this.form.per_sq_ft);
                formData.append('category', this.form.category);
                formData.append('subcategory', this.form.subcategory);
                formData.append('supersubcategory', this.form.supersubcategory);
                formData.append('stock', this.form.stock);
                formData.append('is_featured', this.form.is_featured);
                formData.append('status', this.form.status);
                formData.append('description', this.form.description);
                formData.append('tag', this.form.tag);
                formData.append('type', this.form.type);
                formData.append('product_code', this.code);
                formData.append('is_seller', this.form.is_seller);
                formData.append('is_offer', this.form.is_offer);
                formData.append('under_of', this.form.under_of);
                formData.append('size', this.form.size);
                formData.append('color', this.form.color);
                formData.append('thickness', this.form.thickness);
                formData.append('items', JSON.stringify(this.inputs));
                formData.append('feature',JSON.stringify(this.value));
                
               //console.log(this.form.size)
               //console.log(this.form)
                axios({
                    method: 'POST',
                    url: this.$root.URL_ROOT + 'api.php',
                    data: formData
                }).then(function (response) {
                    console.log(response.data)
                    var data = response.data
                    if (data.status == "success") {
                        ev.$swal({
                            toast: true,
                            position: 'top-end',
                            timer: 5000,
                            icon: 'success',
                            timerProgressBar: true,
                            title: 'Action perform successfully'
                        })
                        ev.$router.push({
                            name: 'index',
                            params: {
                                page: ev.page,
                                action: 'view',
                                id: ev.code,
                                code: ev.code,
                            }
                        })
                    } else {
                        var message = ""
                        setTimeout(() => ev.$swal('Error Please check', message, "error"), 1000);

                    }

                })
            }
        },
        remove(id) {
            var self = this;
            var param = {
                id: id,
                table: 'mss_product',
                type: 'commonDelete'
            }
            this.$swal({
                title: "Delete this ?",
                text: "Are you sure? You won't be able to revert this!",
                icon: 'info',
                showCancelButton: true,
                confirmButtonColor: "#f00",
                confirmButtonText: "Yes, Delete it!",
                reverseButtons: true
            }).then((result) => {
                if (result.isConfirmed) {
                    axios({
                        method: 'POST',
                        url: this.$root.URL_ROOT + 'api.php',
                        data: param
                    }).then(function (response) {
                        var data = response.data;
                        self.allDatas()
                       //console.log('commonDelete', data)
                    })
                }
            })
        },
        AddVarient() {
            this.varient_products.push({
                varient_name: '',
                varient_price: '',
                varient_qty: '',
                varient_image: ''
            });
        },
        deleteRow(index, invoice_product) {
            var idx = this.varient_products.indexOf(invoice_product);
            if (idx > -1) {
                this.varient_products.splice(idx, 1);
            }
        },
    },

    mounted() {
        // alert(this.code)
        if (this.action == "view") {
            this.viewInit()
        } else if (this.action == "edit" && this.id > 0) {
            this.editInit()
        } else if (this.action == "add") {
            this.addInit();
        }
    },
    watch: {
        page2: function (vl) {
           //console.log(vl)
            this.changePage();
        },
        'action': function (val) {
            if (val == "view") {
                this.viewInit()
            } else if (val == "edit" && this.id > 0) {
                this.editInit()
            } else if (val == "add") {
                this.addInit();
            }
        },
        'form.category': function (newVal, oldVal) {
            if (newVal != oldVal) {
                this.getSubCategory(newVal)
            }
        },
        'form.subcategory': function (newVal, oldVal) {
            if (newVal != oldVal) {
                //this.getSuperSubCategory(newVal)
            }
        },
        'form.description': function (val) {
            if (val) {
                this.form.description = val.replace("'", "`");
            }
        },
        status: function (vl) {
            if(vl==1){
                this.status =true;
            }else if(vl==0){
                this.status =false;
            }else{
                this.status =vl;
            }
        }
    }
}
</script>

<style scoped>
@import "~vue2-editor/dist/vue2-editor.css";
</style>
